// extracted by mini-css-extract-plugin
module.exports = {"card":"driver-card_card__1kTgw","illustration":"driver-card_illustration__blLha","title":"driver-card_title__1b7nW","detail":"driver-card_detail__208kQ"};